"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iDashboard = exports.iElement = exports.iLinkElement = exports.iKeyValueElement = exports.iTextElement = void 0;
const t = require("io-ts");
exports.iTextElement = t.interface({
    id: t.union([t.null, t.number]),
    type: t.keyof({
        'TEXT': null,
        'MARKDOWN': null
    }),
    description: t.union([t.string, t.null]),
    value: t.string,
    order: t.number
});
exports.iKeyValueElement = t.interface({
    id: t.union([t.null, t.number]),
    type: t.keyof({
        'KEY-VALUE-COLUMN': null,
        'KEY-VALUE-ROW': null
    }),
    key: t.string,
    value: t.string,
    order: t.number
});
exports.iLinkElement = t.interface({
    id: t.union([t.null, t.number]),
    type: t.literal('LINK'),
    description: t.string,
    url: t.string,
    displayName: t.union([t.null, t.string]),
    order: t.number
});
exports.iElement = t.union([exports.iLinkElement, exports.iTextElement, exports.iKeyValueElement]);
exports.iDashboard = t.intersection([
    t.interface({
        id: t.union([t.null, t.number]),
        name: t.string,
        position: t.number,
        elements: t.array(exports.iElement)
    }),
    t.partial({
        parent: t.keyof({
            'CUSTOMER': null,
            'PROJECT': null
        }),
        customerUuid: t.string,
        projectUuid: t.string,
        locked: t.boolean
    })
]);
//# sourceMappingURL=dashboard.js.map